import FileSaver from 'file-saver';

export const fileSaver = (data: string, fileName?: string): void => {
	const url = new URL(data);
	const pathname = url.pathname;
	const generatedFileName = decodeURIComponent(pathname.substring(pathname.lastIndexOf('/') + 1));

	FileSaver.saveAs(data, fileName ?? generatedFileName);
};
